export enum LanguageCode {
  EN = 'en',
  EN_PIRATE = 'en-pirate',
  EN_JESTER = 'en-jester',
  EN_SASSY = 'en-sassy',
  EN_CHEER = 'en-cheer',
  ES = 'es'
}

export enum Language {
  ENGLISH = 'English',
  SPANISH = 'Spanish'
}
